const RequestStatusEnum = {
    1: {
        label: "Pendente",
        color: "#EB6878",
        key: "PENDING"
    },
    2: {
        label: "Em Análise",
        color: "#DBE0EB",
        key: "UNDER_ANALYSIS"
    },
    3: {
        label: "Finalizada",
        color: "#000000",
        key: "FINISHED"
    }
};

export default RequestStatusEnum;
